// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1a6aP","colMaxWidth":"Table_colMaxWidth__2G9EP"};